<template>
	<div>
		<div class="affairs-list" v-if="taskList">
			<AuthorAffairListItem
				v-for="item in taskList"
				:dataOrder="item"
			/>
		</div>
		<div class="affairs-list" v-if="taskList.length === 0">
			<p>{{ $t('noTask') }}</p>
		</div>
	</div>
</template>

<script>
import AuthorAffairListItem from '@/components/AuthorTasks/AuthorAffairListItem'

import moment from 'moment'
import {groupBy, get, flatMap, orderBy} from 'lodash'

export default {
	name: 'AuthorAffairsList',
	components: {
		AuthorAffairListItem,
	},
	props: {
		taskList: {
		},
		filter:{
			type: Boolean,
			default: false,
		}
	},
	data () {
		return {
			// activePromptAssignToManager: false,
			// taskToAssign: null,
			// assignedManager: null
		}
	},
	computed: {

	},
	methods: {
		onAssignToManager (e) {
			this.$emit('assignToManager', e)
			// this.taskToAssign = e
			// this.activePromptAssignToManager = true
		},
		// assignToManager () {
		//   this.$store.dispatch('calendar/assignTaskToManager', {
		//     task: this.taskToAssign,
		//     manager: {manager_id: this.assignedManager}
		//   })
		// },
		onEditTask (e) {
			this.$emit('editTask', e)
		},
	},
	created() {
		// console.log(this.taskList);
	}

}
</script>

<style scoped lang="scss">
.affairs-list {
	width: 100%;

}
</style>
